import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchPartModels = createAsyncThunk(
    'partModels/fetchPartModels',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartModelsPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch part models');
        }
    }
);

export const getPartModelsOverview = createAsyncThunk(
    'partModels/getPartModelsOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartModelsOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch part models overview');
        }
    }
);

export const createPartModelAsync = createAsyncThunk(
    'partModels/createPartModel',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiService.createPartModel(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create part model');
        }
    }
);

export const updatePartModelAsync = createAsyncThunk(
    'partModels/updatePartModel',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiService.updatePartModel(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update part model');
        }
    }
);

export const deletePartModelAsync = createAsyncThunk(
    'partModels/deletePartModel',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deletePartModel(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete part model');
        }
    }
);

const initialState = {
    partModelsData: null,
    partModelsLoading: false,
    partModelsError: null,
    partModelsOverview: null,
    partModelsOverviewLoading: false,
    createPartModelLoading: false,
    updatePartModelLoading: false,
    deletePartModelLoading: false,
};

const partModelSlice = createSlice({
    name: 'partModels',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPartModels.pending, (state) => {
                state.partModelsLoading = true;
                state.partModelsError = null;
            })
            .addCase(fetchPartModels.fulfilled, (state, action) => {
                state.partModelsLoading = false;
                state.partModelsData = action.payload?.data || null;
                state.partModelsError = null;
            })
            .addCase(fetchPartModels.rejected, (state, action) => {
                state.partModelsLoading = false;
                state.partModelsError = action.payload;
                state.partModelsData = null;
            })
            .addCase(getPartModelsOverview.pending, (state) => {
                state.partModelsOverviewLoading = true;
            })
            .addCase(getPartModelsOverview.fulfilled, (state, action) => {
                state.partModelsOverviewLoading = false;
                state.partModelsOverview = action.payload?.data || null;
            })
            .addCase(getPartModelsOverview.rejected, (state) => {
                state.partModelsOverviewLoading = false;
            })
            .addCase(createPartModelAsync.pending, (state) => {
                state.createPartModelLoading = true;
            })
            .addCase(createPartModelAsync.fulfilled, (state) => {
                state.createPartModelLoading = false;
            })
            .addCase(createPartModelAsync.rejected, (state) => {
                state.createPartModelLoading = false;
            })
            .addCase(updatePartModelAsync.pending, (state) => {
                state.updatePartModelLoading = true;
            })
            .addCase(updatePartModelAsync.fulfilled, (state) => {
                state.updatePartModelLoading = false;
            })
            .addCase(updatePartModelAsync.rejected, (state) => {
                state.updatePartModelLoading = false;
            })
            .addCase(deletePartModelAsync.pending, (state) => {
                state.deletePartModelLoading = true;
            })
            .addCase(deletePartModelAsync.fulfilled, (state) => {
                state.deletePartModelLoading = false;
            })
            .addCase(deletePartModelAsync.rejected, (state) => {
                state.deletePartModelLoading = false;
            });
    },
});

export default partModelSlice.reducer;
